export const DPNETWORK = 'DPNETWORK'